module.exports = __webpack_public_path__ + "../resources/images/illustration_search_file-a6d2656e82e13e3fccac638e151532b3.svg";